import { QA_STATUSES, type QAStatusType } from '@intone/shared';

// Get status color for badges
export const getStatusColor = (status: QAStatusType | string): string => {
  switch (status) {
    case QA_STATUSES.CRITICAL:
      return 'bg-red-100 text-red-700 border-red-200'
    case QA_STATUSES.MEDIUM_PRIORITY:
      return 'bg-orange-100 text-orange-700 border-orange-200'
    case QA_STATUSES.LOW_PRIORITY:
      return 'bg-yellow-100 text-yellow-700 border-yellow-200'
    case QA_STATUSES.NEED_INFORMATION:
      return 'bg-blue-100 text-blue-700 border-blue-200'
    case QA_STATUSES.REVIEWED:
      return 'bg-emerald-100 text-emerald-700 border-emerald-200'
    case QA_STATUSES.RESOLVED:
      return 'bg-green-100 text-green-700 border-green-200'
    default:
      return 'bg-gray-100 text-gray-600 border-gray-200'
  }
};

export const getStatusBgColor = (status: string): string => {
  switch (status) {
    case QA_STATUSES.CRITICAL:
      return 'bg-red-400'
    case QA_STATUSES.MEDIUM_PRIORITY:
      return 'bg-orange-400'
    case QA_STATUSES.LOW_PRIORITY:
      return 'bg-yellow-400'
    case QA_STATUSES.NEED_INFORMATION:
      return 'bg-blue-400'
    case QA_STATUSES.REVIEWED:
      return 'bg-emerald-400'
    case QA_STATUSES.RESOLVED:
      return 'bg-green-400'
    default:
      return 'bg-gray-400'
  }
};

// Light, readable colors for issue types
export const getCategoryColor = (index: number): string => {
  const lightColors = [
    'bg-blue-300',
    'bg-indigo-300',
    'bg-purple-300',
    'bg-pink-300',
    'bg-rose-300',
    'bg-orange-300',
    'bg-amber-300',
    'bg-yellow-300',
    'bg-lime-300',
    'bg-green-300',
    'bg-emerald-300',
    'bg-teal-300',
    'bg-cyan-300',
    'bg-sky-300',
    'bg-violet-300',
  ]
  return lightColors[index % lightColors.length]
};

export function getDispositionColor(disposition: string) {
  const successDispositions = ['CALLBK', 'SUCCESS'];
  const failureDispositions = ['DNC', 'DF'];
  const warningDispositions = ['NI', 'NQ'];
  const greyDispositions = ['A', 'AM', 'DAIR', 'NA', 'AA', 'AB'];

  if (successDispositions.includes(disposition)) return 'bg-green-100 text-green-800';
  if (failureDispositions.includes(disposition)) return 'bg-red-100 text-red-800';
  if (warningDispositions.includes(disposition)) return 'bg-yellow-100 text-yellow-800';
  if (greyDispositions.includes(disposition)) return 'bg-gray-700 text-white';
  return 'bg-gray-100 text-gray-800';
}